















import Vue from "vue";
import { common_state } from "./data/common.state";
import { automate_state } from "./data/automate.state";
import { computed, onMounted, watch } from "@vue/composition-api";
import AutomatePage from "./automate/index.vue";
import LinearLoader from "@/components/LinearLoader.vue";
import Concent from "./Concent.vue";
import { SharedState } from "@/common/state";
import { DEFAULT_PROVIDER, LabelProvider } from "./data/provider";

export default Vue.extend({
  components: {
    AutomatePage,
    LinearLoader,
    Concent,
  },
  props: {
    /**
     * Which external label provider this screen configures. Microsoft is the
     * default so the existing MIP route is unchanged; the Google Drive route
     * passes "google" (see views/customize/google-labeling/index.vue).
     */
    provider: { type: String, default: DEFAULT_PROVIDER },
  },
  setup(props) {
    const { init_common_state, has_setup_status_known } = common_state;
    const should_mock = () => SharedState.env.value.env == "uat";

    // Set before first render so the screen is never briefly on the wrong
    // provider. Mappings are not loaded here: the child screen loads them once
    // common state is ready, and firing that now would fetch before the labels
    // exist and filter the table down to nothing.
    common_state.set_provider(props.provider as LabelProvider);

    // The two routes render this same component, so if vue-router ever reuses
    // the instance the prop moves without a remount. Lazy, because the line
    // above already covers the initial value — this handles only real changes,
    // where the mappings must be refetched for the provider we moved to.
    watch(
      () => props.provider,
      (provider) => {
        common_state.set_provider(provider as LabelProvider);
        automate_state.init();
      },
      { lazy: true }
    );

    const is_provider_ready = computed(() =>
      common_state.is_provider_ready(props.provider as LabelProvider)
    );

    onMounted(() => {
      SharedState.onReady(async () => {
        if (should_mock()) {
          // @ts-ignore
          window.toggle_mock(true);
        }
        await init_common_state();
      });
    });
    return {
      has_setup_status_known,
      is_provider_ready,
    };
  },
});
